import React, { useState } from 'react'
import {
  Form,
  Input,
  Modal as AntdModal,
  Alert,
  InputNumber,
  Row,
  Col,
  message,
  Radio,
} from 'antd'
import { updateTry, fetchUpdateHardware } from '@/api/equipment'

const Modal = (props) => {
  const {
    form,
    current,
    visible,
    onCancel = () => {},
    getContainer,
    onRefresh = () => {},
    selectedRowKeys,
  } = props
  const [updateType, setUpdateType] = useState(1)
  const handleConfirm = () => {
    form.validateFields((err, values) => {
      if (!err) {
        if (current || selectedRowKeys.length) {
          if (updateType == 1) {
            updateTry({
              capsuleIdList: current.capsuleId
                ? [current.capsuleId]
                : selectedRowKeys,
            }).then((res) => {
              if (res.success) {
                onRefresh()
                message.success('更新成功')
              }
            })
          } else if (updateType == 2) {
            fetchUpdateHardware({
              capsuleIdList: current.capsuleId
                ? [current.capsuleId]
                : selectedRowKeys,
              position: 'control',
            }).then((res) => {
              if (res.success) {
                onRefresh()
                message.success('更新成功')
              }
            })
          }
        }
      }
    })
  }
  const handleChange = (e) => {
    setUpdateType(e.target.value)
  }
  return (
    <AntdModal
      destroyOnClose={true}
      title={'版本更新'}
      visible={visible}
      onOk={handleConfirm}
      onCancel={onCancel}
      width={710}
      wrapClassName={'modal'}
      getContainer={getContainer}>
      <div className='pl-24'>
        <Alert
          message={`最新启用的${updateType == 1 ? '软件' : '硬件'}版本：${
            updateType == 1
              ? current.enableVersionName
                ? current.enableVersionName
                : '无'
              : current.enableHardwareVersion
              ? current.enableHardwareVersion
              : '无'
          }`}
          type='info'
        />
        <Form layout='inline'>
          <Form.Item label='更新类型' required>
            <Radio.Group onChange={handleChange} value={updateType}>
              <Radio value={1}>软件更新</Radio>
              <Radio value={2}>硬件更新</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </div>
    </AntdModal>
  )
}

export default Form.create()(Modal)
